import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import Item from '../../../shared/TechSkills/Item';
import AddItem from '../../../shared/TechSkills/AddItem';
import config from '../../../config';
import DragNDropList from '../../../shared/DragNDropList';

const VersionControlSystemsTab = ({ data, onChange }) => {
  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  useEffect(() => {
    if (!('versionControlSystems' in data)) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'versionControlSystems',
          value: {
            enable: false,
            heading: 'versionControlSystems',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    'versionControlSystems' in data && (
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab">{t('versionControlSystems.title.label')}</div>

          <div className="col-span-1">
            <Checkbox
              checked={data.versionControlSystems.enable}
              onChange={v => onChange('data.versionControlSystems.enable', v)}
            />
          </div>
        </div>

        <hr className="my-6" />

        <DragNDropList
          data={data}
          dispatch={dispatch}
          onChange={onChange}
          type="versionControlSystems"
        >
          {data.versionControlSystems.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.versionControlSystems.items.length - 1}
              type='versionControlSystems'
              idTab={config.TECH_SKILLS_TABS.versionControlSystems}
            />
          ))}
        </DragNDropList>


        <AddItem heading='Technology' dispatch={dispatch} type='versionControlSystems' idTab={config.TECH_SKILLS_TABS.versionControlSystems} />
      </>
    )
  );
};

export default VersionControlSystemsTab;
